function SizesViewerCtrl() {
  var ctrl = this;
  ctrl.$onInit = function () {
    if (ctrl.startSelectedSizes != null && ctrl.startSelectedSizes.length > 0) {
      for (var s = 0, lenS = ctrl.startSelectedSizes.length; s < lenS; s++) {
        for (var c = 0, lenC = ctrl.sizes.length; c < lenC; c++) {
          if (ctrl.sizes[c].SizeId === ctrl.startSelectedSizes[s]) {
            ctrl.sizeSelected = ctrl.sizes[c];
            break;
          }
        }
      }
    }
    ctrl.initSizes({
      sizesViewer: ctrl
    });
  };
  ctrl.viewPopover = (event, size) => {
    ctrl.viewSize = size.AdditionalSize;
    ctrl.viewPopoverSize({
      popoverName: 'popoverSizeViewer',
      event: event
    });
    //popoverService.getPopoverScope('popoverSizeViewer').then(function (popoverScope) {
    //    popoverScope.active(element);

    //    if (timerPopoverHide != null) {
    //        $timeout.cancel(timerPopoverHide);
    //    }

    //    timerPopoverHide = $timeout(function () {
    //        popoverScope.deactive();
    //    }, 5000);
    //});
  };
}

;
export default SizesViewerCtrl;